import { connect } from 'react-redux';
import { isEmpty } from 'react-redux-firebase';
import { Link } from 'react-router-dom';
import React from 'react';
import styled from 'react-emotion';

import AuthLinksDropdown from './AuthLinksDropdown/AuthLinksDropdown';
import Button from '../../../components/Buttons/Button';
import { signOut } from '../../../redux/actions/signOut';
import Style from '../../../styles/common';
import { CATEGORY, SIZE, TIER } from '../../../components/Buttons/constants';

const Container = styled('div')``;

const ButtonLink = styled(Link)`
  margin-right: ${Style.SPACING.S};
`;

class AuthLinks extends React.Component {
  render() {
    if (isEmpty(this.props.auth)) {
      return (
        <Container>
          <ButtonLink to="/auth">
            <Button
              category={CATEGORY.DARK}
              size={SIZE.S}
              tier={TIER.SECONDARY}
            >
              Sign in
            </Button>
          </ButtonLink>
          <Link to="/auth/signUp">
            <Button category={CATEGORY.DARK} size={SIZE.S}>Sign up</Button>
          </Link>
        </Container>
      );
    } else {
      return (
        <Container>
          <ButtonLink to="/create-event">
            <Button category={CATEGORY.NEUTRAL} size={SIZE.S}>
              Create event
            </Button>
          </ButtonLink>
          <AuthLinksDropdown onSignOut={this.props.signOut} />
        </Container>
      )
    }
  }
}

export default connect(
  state => ({
    auth: state.firebase.auth,
  }),
  { signOut },
)(AuthLinks);



// WEBPACK FOOTER //
// ./src/views/Masthead/AuthLinks/AuthLinks.js